module.exports = "build/assets/PensumPro-Bold.57023634.woff2";